// Function to handle the observed changes
function handleChanges(mutationsList, observer) {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      // A child element has been added or removed
      updateButtonText();
      ;
    }
  }
}

// Function to update the button text
function updateButtonText() {
  let links_list = document.querySelectorAll(".boost-sd__button-text");
  if (links_list.length > 0) {
    links_list.forEach((link) => {
      if (link.innerText === "ADD TO QUOTE") {
        let btn = link.closest("button");
        let a_ = link.closest("a")
        if(a_){
           btn.addEventListener('click', (e) => { 
              e.preventDefault();
             if(a_){ a_.click();}
             
          }, true); 
        }else{
          let x = link.closest(".boost-sd__quick-view-product-info").querySelector("a").cloneNode(true);
          x.classList = btn.classList;
          x.innerText = btn.innerText;
          btn.parentNode.replaceChild(x,btn);
          x.style.background = "black";
          x.style.color = "white";
        }
          
      }
    });
  }
}

// Create a new observer with the callback function
const observer = new MutationObserver(handleChanges);

// Start observing changes in the body and its descendants
observer.observe(document.body, { childList: true, subtree: true });

// Call the update function initially (in case the elements are already present)
updateButtonText();
